import { Navigation, PremadeQuizCardComponent } from '@quizzach/components';
import {
	CardsGrid,
	PhHead,
	PremadePage,
	SearchBoxSkin,
} from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';
import { useEffect } from 'react';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { InstantSearch, SearchBox, useHits } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import { IPremadeQuiz } from '@quizzach/interfaces';
import { Reveal } from '@quizzach/motion';

const searchClient = algoliasearch(
	'T6WTMCW27P',
	'145a84076bea619ed2273ef0ddda5e7b'
);

const CustomHits = () => {
	const { items } = useHits<IPremadeQuiz>();

	return (
		<CardsGrid style={{ paddingBottom: '90px' }}>
			{items.map((item: IPremadeQuiz) => (
				<PremadeQuizCardComponent quiz={item} key={item.uuid} />
			))}
		</CardsGrid>
	);
};

export const PremadeSearch = () => {
	const { t } = useTranslation();

	useEffect(() => {
		scrollToTop();
	}, []);

	return (
		<PremadePage>
			<Navigation />

			<PhHead>
				<Reveal as='h1'>{t('premade.search.link')}</Reveal>
			</PhHead>

			<InstantSearch
				searchClient={searchClient}
				indexName={`${import.meta.env.VITE_ALGOLIA_SEARCH_ENV}_premadeQuizzes`}
			>
				<SearchBoxSkin>
					<SearchBox
						placeholder={t('premade.search.placeholder')}
						className='search-box'
					/>
				</SearchBoxSkin>
				<CustomHits />
			</InstantSearch>
		</PremadePage>
	);
};
